import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ref, set } from "firebase/database";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import { auth, database } from "../firebase";
import { toast } from "react-toastify";

const Signup = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    dob: "",
    gender: "",
    country: "",
    phone: "",
    interests: [],
    terms: false,
  });

  const interestsOptions = [
    "Technology",
    "Health & Wellness",
    "Sports",
    "Fashion",
    "Travel",
    "Food & Cooking",
    "Entertainment",
    "Finance",
  ];

  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo (Congo-Brazzaville)",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Democratic Republic of the Congo",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar (Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Korea",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine State",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Republic of the Congo",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "Other",
  ];


  const validate = () => {
    if (!form.name.trim()) return toast.error("Full Name is required."), false;
    if (!form.email.trim()) return toast.error("Email is required."), false;
    if (!/\S+@\S+\.\S+/.test(form.email))
      return toast.error("Email is invalid."), false;
    if (!form.password) return toast.error("Password is required."), false;
    if (form.password.length < 6)
      return toast.error("Password must be at least 6 characters."), false;
    if (!form.dob) return toast.error("Date of Birth is required."), false;

    const birthDate = new Date(form.dob);
    const age =
      new Date(Date.now() - birthDate.getTime()).getUTCFullYear() - 1970;
    if (age < 18)
      return toast.error("You must be at least 18 years old."), false;

    if (!form.gender) return toast.error("Gender is required."), false;
    if (!form.country) return toast.error("Country is required."), false;
    if (form.phone && !/^\+?[0-9\s\-]{7,15}$/.test(form.phone))
      return toast.error("Phone number is invalid."), false;
    if (form.interests.length === 0)
      return toast.error("Select at least one interest."), false;
    if (!form.terms)
      return (
        toast.error("You must agree to the terms and privacy policy."), false
      );

    return true;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox" && name === "interests") {
      const updated = checked
        ? [...form.interests, value]
        : form.interests.filter((i) => i !== value);
      setForm({ ...form, interests: updated });
    } else if (type === "checkbox" && name === "terms") {
      setForm({ ...form, terms: checked });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        form.email,
        form.password
      );
      const user = userCredential.user;

      await sendEmailVerification(user);

      await set(ref(database, `users/${user.uid}`), {
        name: form.name,
        email: form.email,
        dob: form.dob,
        gender: form.gender,
        country: form.country,
        phone: form.phone,
        interests: form.interests,
        emailVerified: false,
        createdAt: Date.now(),
      });

      await set(ref(database, `Points/${user.uid}`), {
        point_earned: 0,
        point_redeemed: 0,
        point_available: 0,
        point_expired: 0,
        point_review: 0,
        point_rejected: 0,
      });

      toast.success("Verification email sent! Check your inbox.");
      navigate("/login");
    } catch (error) {
      toast.error(`Signup failed: ${error.message}`);
    }
  };

  return (
    <div className="auth-page">
      <aside className="auth-brand-panel">
        <div className="auth-brand-lockup"><img src={require("../logo.png")} alt="Teqluc Research" /></div>
        <div className="auth-brand-content"><span className="auth-overline">A COMMUNITY THAT COUNTS</span><h1>Your voice can shape what comes next.</h1><p>Join a community sharing real opinions to help brands and researchers make better decisions.</p><ul><li><span>✓</span> Your opinion matters</li><li><span>✓</span> Rewards for your time</li><li><span>✓</span> Your data deserves respect</li></ul></div>
        <div className="auth-brand-footer">TEQLUC RESEARCH · YOUR VOICE, BETTER INSIGHTS</div>
      </aside>
      <main className="auth-main auth-main-signup"><div className="auth-card auth-card-wide">
        <div className="auth-form-heading"><span className="eyebrow">JOIN THE COMMUNITY</span><h2>Create your account</h2><p>Set up your panel profile to start finding surveys.</p></div>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-grid auth-form-grid">
            <div className="form-field"><label htmlFor="name">Full name</label><input className="field-input" id="name" name="name" value={form.name} onChange={handleChange} autoComplete="name" required placeholder="Your full name" /></div>
            <div className="form-field"><label htmlFor="email">Email address</label><input className="field-input" id="email" name="email" type="email" value={form.email} onChange={handleChange} autoComplete="email" required placeholder="you@example.com" /></div>
            <div className="form-field"><label htmlFor="password">Password</label><input className="field-input" id="password" name="password" type="password" value={form.password} onChange={handleChange} autoComplete="new-password" required minLength={6} placeholder="At least 6 characters" /></div>
            <div className="form-field"><label htmlFor="dob">Date of birth</label><input className="field-input" id="dob" name="dob" type="date" max={new Date().toISOString().split("T")[0]} value={form.dob} onChange={handleChange} required /></div>
            <div className="form-field"><label htmlFor="gender">Gender</label><select className="field-input" id="gender" name="gender" value={form.gender} onChange={handleChange} required><option value="">Select gender</option><option value="female">Female</option><option value="male">Male</option><option value="nonbinary">Non-binary</option><option value="prefer_not_say">Prefer not to say</option></select></div>
            <div className="form-field"><label htmlFor="country">Country</label><select className="field-input" id="country" name="country" value={form.country} onChange={handleChange} required><option value="">Select country</option>{countries.map(country => <option key={country} value={country}>{country}</option>)}</select></div>
            <div className="form-field"><label htmlFor="phone">Phone number <span className="optional-label">Optional</span></label><input className="field-input" id="phone" name="phone" type="tel" value={form.phone} onChange={handleChange} autoComplete="tel" placeholder="+1 555 000 0000" /></div>
          </div>
          <fieldset className="auth-interest-fieldset"><legend>What topics interest you?</legend><div className="auth-interest-grid">{interestsOptions.map(interest=><label className="auth-interest" key={interest}><input type="checkbox" name="interests" value={interest} checked={form.interests.includes(interest)} onChange={handleChange}/><span>{interest}</span></label>)}</div></fieldset>
          <label className="auth-terms-check"><input type="checkbox" name="terms" checked={form.terms} onChange={handleChange}/><span>I agree to the <a href="https://teqluc.in/terms" target="_blank" rel="noreferrer">Terms & Conditions</a> and <a href="https://teqluc.in/privacy" target="_blank" rel="noreferrer">Privacy Policy</a>.</span></label>
          <button className="btn btn-primary auth-submit" type="submit">Create account <span>→</span></button>
        </form>
        <p className="auth-switch">Already have an account? <Link to="/login">Sign in</Link></p>
      </div></main>
    </div>
  );
};

export default Signup;

const renderInput = (
  label,
  name,
  value,
  onChange,
  type = "text",
  max = "",
  placeholder = ""
) => (
  <>
    <label htmlFor={name} style={styles.label}>{label}</label>
    <input
      id={name}
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      max={max}
      style={styles.input}
      onFocus={(e) => (e.target.style.boxShadow = "0 0 0 3px rgba(143, 39, 255, 0.2)")}
      onBlur={(e) => (e.target.style.boxShadow = "none")}
    />
  </>
);

const renderSelect = (label, name, value, onChange, options = []) => (
  <>
    <label htmlFor={name} style={styles.label}>{label}</label>
    <select
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      style={styles.input}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  </>
);

const styles = {
  container: {
    display: "flex",
    height: "100vh",
    overflow: "hidden",
    fontFamily: "'Inter', sans-serif",
  },
  leftPanel: {
    flex: 1,
    overflowY: "auto",
    backgroundColor: "#f9f9f9",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "2rem",
  },
  rightPanel: {
    flex: 1,
    background: "linear-gradient(to bottom right, #8F27FF, #200D41)",
    color: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem",
  },
  card: {
    background: "#fff",
    borderRadius: "16px",
    boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
    width: "100%",
    maxWidth: "500px",
    padding: "2rem",
    marginBottom: "5rem",
  },
  title: {
    fontSize: "28px",
    fontWeight: 700,
    color: "#200D41",
    marginBottom: "1.5rem",
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "6px",
    fontWeight: 600,
    fontSize: "15px",
    color: "#333",
  },
  input: {
    padding: "12px 14px",
    marginBottom: "20px",
    borderRadius: "10px",
    border: "1.5px solid #d0cde1",
    fontSize: "15px",
    backgroundColor: "#fff",
    transition: "all 0.2s ease",
    outline: "none",
  },
  primaryBtn: {
    backgroundColor: "#8F27FF",
    color: "#fff",
    border: "none",
    padding: "14px",
    borderRadius: "10px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: 600,
    transition: "all 0.2s ease",
    marginTop: "12px",
  },
  fieldset: {
    marginBottom: "1.5rem",
    padding: "1rem",
    border: "1px solid #eee",
    borderRadius: "10px",
    backgroundColor: "#fefefe",
  },
  legend: {
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: "0.8rem",
    color: "#200D41",
  },
  checkboxGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
    gap: "10px",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: "14px",
    color: "#333",
  },
  link: {
    color: "#8F27FF",
    textDecoration: "none",
    fontWeight: 600,
    transition: "color 0.2s ease",
  },
  footerText: {
    fontSize: "14px",
    color: "#444",
    textAlign: "center",
    marginTop: "20px",
  },
};
